module.exports = __webpack_public_path__ + "img/card_center.66f7e6f4.png";